"use client";

import { useEffect, useState } from "react";
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarInset, SidebarProvider, useSidebar } from "@/components/ui/sidebar";
import { DataStreamProvider } from "@/components/data-stream-provider";
import { useSelector, useDispatch } from "react-redux";
import ProjectPopup from "@/components/projectPopup";
import { setShowProjectPopup } from "@/store/mainSlice";

export default function ClientLayout({ isCollapsed, children }) {
  const dispatch = useDispatch();
  const { activeNavItem, showProjectPopup } = useSelector((state) => state.main);
  return (
    <DataStreamProvider>
      <SidebarProvider defaultOpen={isCollapsed}>
        <AppSidebar onProjectsClick={() => dispatch(setShowProjectPopup(true))} />
        <SidebarInset activeMainItem={activeNavItem}>{children}</SidebarInset>
         {/* popup render here */}
        <ProjectPopup open={showProjectPopup} onClose={() => dispatch(setShowProjectPopup(false))} />
      </SidebarProvider>
    </DataStreamProvider>
  );
}


